module.exports = __webpack_public_path__ + "img/amazon.675feec.svg";